module.exports = __webpack_public_path__ + "fonts/Didot-Bold.0ca5d3ce.ttf";